import React from 'react';
import { _cs } from '@togglecorp/fujs';
import { IoCheckbox, IoSquareOutline } from '../../../node_modules/react-icons/io5/index.esm.js';
import { genericMemo } from '../../../utils/index.js';
import ElementFragments from '../../ElementFragments/index.js';
import styles from './styles.css.js';

var _IoCheckbox, _IoSquareOutline;

function Option(props) {
  const {
    children,
    isActive,
    ellipsize = false
  } = props;
  return /*#__PURE__*/React.createElement(ElementFragments, {
    icons: isActive ? _IoCheckbox || (_IoCheckbox = /*#__PURE__*/React.createElement(IoCheckbox, null)) : _IoSquareOutline || (_IoSquareOutline = /*#__PURE__*/React.createElement(IoSquareOutline, null)),
    childrenContainerClassName: styles.labelContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: _cs(styles.label, ellipsize && styles.ellipsis),
    title: typeof children === 'string' ? children : undefined
  }, children));
}

var Option$1 = genericMemo(Option);

export { Option$1 as default };
//# sourceMappingURL=index.js.map
